<template>
  <ContentPage back>
    <template #header>
      <content-page-title>
        Pro User Agreement
      </content-page-title>
    </template>
    <div class="pa-2 white rounded-lg">
      <TOS />
    </div>
  </ContentPage>
</template>

<script>
import { ContentPage, ContentPageTitle } from '@/components/pages'
import TOS from '@/components/documents/ProTOS_2025_08_28'

export default {
  name: 'LegalTOS',

  components: { ContentPage, ContentPageTitle, TOS },
}
</script>